import { PostMessageControllerComponent } from "../component"
import { PostMessageRequest } from "../../../data"

export default function handleOpenStartPage(this: PostMessageControllerComponent, data: PostMessageRequest) {
    if (data.openStartPage) {
        this.props.history.push("/")
    }
}
